import { useContext } from "react";
import { LoadingContext } from "../contexts/loadingContext";

export default () => {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error("Wrap your app in LoadingProvider");
  }

  return context;
};
